import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  inject,
} from "@angular/core";
import { WindowConfig, WindowManagerService } from "./window-manager.service";

@Component({
  selector: "app-window-content-wrapper",
  standalone: true,
  imports: [CommonModule],
  template: `
    <div #contentWrapper class="window-content-wrapper">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      .window-content-wrapper {
        width: 100%;
        box-sizing: border-box;
      }
    `,
  ],
})
export class WindowContentWrapperComponent implements AfterViewInit, OnDestroy {
  @Input() window!: WindowConfig;
  @ViewChild("contentWrapper", { static: true }) contentWrapper!: ElementRef;

  private windowService = inject(WindowManagerService);
  private resizeObserver: ResizeObserver | null = null;
  private updateTimeout: any = null;

  ngAfterViewInit() {
    this.setupResizeObserver();
  }

  ngOnDestroy() {
    this.cleanupResizeObserver();
  }

  private setupResizeObserver() {
    if (!this.contentWrapper?.nativeElement || !("ResizeObserver" in window)) {
      return;
    }

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        this.debouncedUpdateHeight(entry.contentRect.height);
      }
    });

    this.resizeObserver.observe(this.contentWrapper.nativeElement);
  }

  private cleanupResizeObserver() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
      this.updateTimeout = null;
    }
  }

  private debouncedUpdateHeight(height: number) {
    // Debounce pour éviter trop d'appels
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(() => {
      this.windowService.updateContentHeight(this.window, height);
    }, 100);
  }

  // Méthode publique pour forcer une mise à jour de la hauteur
  updateHeight() {
    if (this.contentWrapper?.nativeElement) {
      const height = this.contentWrapper.nativeElement.scrollHeight;
      this.windowService.updateContentHeight(this.window, height);
    }
  }
}
